module.exports = __webpack_public_path__ + "img/service-setting-item5.b8222d87.png";